import PropTypes from 'prop-types';
import React from 'react';

import AnalyticsBlock from '../containers/AnalyticsBlock';
import RangeFilter from '../containers/RangeFilter';
import Layout from '../../components/Layout';
import BarberSelect from '../containers/BarberSelectContainer';
import DirtyFilterOverlay from '../../components/DirtyFilterOverlay';
import ShopFilter from '../../filters/ShopFilter';
import { grossSalesKinds } from '../../constants';

const Analytics = ({
  showBarberSelector,
  totalSales,
  newCustomers,
  productCount,
  serviceCount,
  totalSalesWithTax,
  netProductRevenue,
  netServiceRevenue,
  onDateChange,
  onBarberChange,
  filters,
  showShopSelector,
  grossSalesKind,
}) => (
  <Layout title="Analytics">
    <div className="o-wrapper medium-and-down-p-- large-and-up-pb large-and-up-pt++">
      <div className="c-panel">
        <div className="c-panel__header o-flexbox o-flexbox--justify-start o-flexbox--content-align-end">
          <BarberSelect
            display-if={showBarberSelector}
            ranges={filters}
            onChange={onBarberChange}
          />
          <RangeFilter
            hasCompare
            onChange={onDateChange}
            selectedBarberId={filters.selectedBarberId}
          />
          <div className="c-report-filters u-mt" display-if={showShopSelector}>
            <ShopFilter className="u-border-1px" />
          </div>
        </div>
        <div className="u--m u-position-relative">
          <DirtyFilterOverlay />
          <AnalyticsBlock
            title="Gross sales + taxes"
            data={totalSalesWithTax}
            format="price"
            display-if={grossSalesKind === grossSalesKinds.grossSalesPlusTaxes}
            automationIdBase="totalSalesWithTax"
          />
          <AnalyticsBlock title="Gross sales" data={totalSales} format="price" automationIdBase="totalSales" />
          <AnalyticsBlock
            title="Net Sales - Services"
            data={netServiceRevenue}
            format="price"
            automationIdBase="netServiceRevenue"
          />
          <AnalyticsBlock
            title="Net Sales - Products"
            data={netProductRevenue}
            format="price"
            automationIdBase="netProductRevenue"
          />
          <AnalyticsBlock title="Total services performed" data={serviceCount} automationIdBase="serviceCount" />
          <AnalyticsBlock title="Products Sold" data={productCount} automationIdBase="productCount" />
          <AnalyticsBlock title="New clients" data={newCustomers} automationIdBase="newCustomers" />
        </div>
      </div>
    </div>
  </Layout>
);

const analyticsBlock = PropTypes.shape({
  first: PropTypes.number,
  second: PropTypes.number,
});

Analytics.propTypes = {
  netServiceRevenue: analyticsBlock.isRequired,
  serviceCount: analyticsBlock.isRequired,
  netProductRevenue: analyticsBlock.isRequired,
  newCustomers: analyticsBlock.isRequired,
  totalSales: analyticsBlock.isRequired,
  productCount: analyticsBlock.isRequired,
  totalSalesWithTax: analyticsBlock.isRequired,
  showBarberSelector: PropTypes.bool.isRequired,
  onDateChange: PropTypes.func.isRequired,
  onBarberChange: PropTypes.func.isRequired,
  filters: PropTypes.object.isRequired,
  showShopSelector: PropTypes.bool.isRequired,
  grossSalesKind: PropTypes.string.isRequired,
};

export default Analytics;
